export function downloadCanvasAsPNG(canvas, downloadName) {
    const url = canvas.toDataURL("image/png");
    downloadURL(url, downloadName);
    URL.revokeObjectURL(url);
}
export function downloadURL(url, downloadName) {
    const linkElement = document.createElement("a");
    linkElement.href = url;
    if (downloadName) {
        linkElement.download = downloadName;
    }
    document.body.appendChild(linkElement);
    linkElement.click();
    document.body.removeChild(linkElement);
}
